export const FinishFlag = () => {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.01758" y="2.73828" width="3.96571" height="3.96571" fill="#2E5D4B" />
            <rect x="0.5" y="0.5" width="3.00037" height="3.00037" fill="#2E5D4B" />
            <rect x="6.5" y="6.5" width="3.00037" height="3.00037" fill="#2E5D4B" />
            <rect x="6.48047" y="0.5" width="3.00037" height="3.00037" fill="#2E5D4B" />
            <rect x="0.519531" y="6.48828" width="3.00037" height="3.00037" fill="#2E5D4B" />
        </svg>
    );
};
